type Props = {
  title: string;
  description?: string;
  actions?: React.ReactNode;
  breadcrumb?: string;
};

export function LeavePageHeader({ title, description, actions, breadcrumb }: Props) {
  return (
    <div className="flex flex-wrap items-start justify-between gap-4 border-b border-slate-100 pb-5">
      <div className="min-w-0">
        {breadcrumb && (
          <p className="mb-1 text-xs font-semibold uppercase tracking-widest text-slate-400">
            {breadcrumb}
          </p>
        )}
        <h1 className="text-xl font-bold tracking-tight text-slate-900">{title}</h1>
        {description && (
          <p className="mt-1 text-sm text-slate-500">{description}</p>
        )}
      </div>
      {actions && (
        <div className="flex flex-shrink-0 flex-wrap items-center gap-2">{actions}</div>
      )}
    </div>
  );
}
